module.exports = __webpack_public_path__ + "img/zhanwei1.10c64f9.png";